'use strict';

angular.module('internal.inspections')
    .controller('InternalInspectionsInspectors', ['$scope', 'UserInspectors', 'Users', '$filter', '$uibModal', function ($scope, UserInspectors, Users, $filter, $uibModal) {
        $scope.selectedLoading = true;
        $scope.availableLoading = true;

        $scope.getInspectors = function () {
            $scope.selectedLoading = true;
            UserInspectors.get().then(function (inspectors) {
                $scope.selectedInspectors = inspectors;
                $scope.selectedLoading = false;
            })
        }

        $scope.getUsers = function () {
            $scope.availableLoading = true;
            Users.get({externalOnly: false, hideLockedOrInactive: true}).then(function (users) {
                $scope.availableUsers = $filter('filter')(users, function(user) {return !user.is_inspector});
                $scope.availableLoading = false;
            })
        }

        $scope.getInspectors();
        $scope.getUsers();

        $scope.remove = function (id) {
            $uibModal.open({
                animation: true,
                templateUrl: 'templates/confirm/confirm.html',
                controller: 'ConfirmModalController',
                resolve: {
                    message: function () {
                        return "Are you sure you want to remove this user as an inspector?  This will remove the inspector from all inspections they have completed.";
                    }
                }
            }).result.then(function (result) {
                if (result) {
                    UserInspectors.delete(id).then(function () {
                        $scope.getInspectors();
                        $scope.getUsers();
                    })
                }
            })
        }

        $scope.add = function (id) {
            if (!$scope.adding && !$scope.selectedLoading && !$scope.availableLoading) {
                $scope.adding = true;
                UserInspectors.save({ user_id: id }).then(function() {
                    $scope.getInspectors();
                    $scope.getUsers();
                    $scope.adding = false;
                });
            }
        }

        // not sure how to not have $parent stuff
        $scope.selectedColumns = [
            {
                label: 'Name',
                field: 'user.full_name'
            },
            {
                label: 'Username',
                field: 'user.user_name'
            },
            {
                label: 'Email',
                field: 'user.email'
            },
            {
                label: 'Remove',
                html: '<hlp-icon classes="delete" name="remove" ng-click="$parent.$parent.$parent.$parent.$parent.remove($parent.$parent.$parent.record.id)"></hlp-icon>',
                type: 'empty'
            }
        ];

        // not sure how to not have $parent stuff
        $scope.availableColumns = [
            {
                label: 'Name',
                field: 'full_name'
            },
            {
                label: 'Username',
                field: 'user_name'
            },
            {
                label: 'Email',
                field: 'email'
            },
            {
                label: 'Add',
                html: '<hlp-icon classes="add" name="add" ng-click="$parent.$parent.$parent.$parent.$parent.add($parent.$parent.$parent.record.id)"></hlp-icon>',
                type: 'empty'
            }
        ];

        $scope.selectedFilters = [
            {
                name: 'All Personnel Types',
                field: 'user.internal',
                options: [
                    { name: 'External', id: false },
                    { name: 'Internal', id: true }
                ]
            }
        ];

        $scope.availableFilters = [
            {
                name: 'All Personnel Types',
                field: 'internal',
                options: [
                    { name: 'External', id: false },
                    { name: 'Internal', id: true }
                ]
            }
        ];
    }])
;